import { InternalUserActivationStatus } from "types/enum";

import { DateDisplayDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

import { getUserStatusMappings } from "entity/internalUser/InternalUserDetails/common/InternalUserUtils";
import { type IInternalUserStatusData } from "entity/internalUser/InternalUserDetails/InternalUser.api.types";

interface IInternalUserLoginStatusProps {
    internalUserStatusData: IInternalUserStatusData;
    forAssignedUsers?: boolean;
}
export const InternalUserLoginStatus: React.FC<IInternalUserLoginStatusProps> = ({
    internalUserStatusData,
    forAssignedUsers = false,
}) => {
    const userStatusMapping = getUserStatusMappings(internalUserStatusData, forAssignedUsers);

    return (
        <StatusTagDisplay
            statusType={userStatusMapping.statusType}
            statusText={userStatusMapping.statusMessage}
            popoverContent={
                forAssignedUsers ? undefined : (
                    <span>
                        Active since{" "}
                        <DateDisplayDate
                            value={
                                new Date(
                                    internalUserStatusData.accountConfirmationDate?.toDate() ?? "",
                                )
                            }
                            data-testid="login-status-date"
                        />
                    </span>
                )
            }
            disablePopover={
                forAssignedUsers
                    ? true
                    : internalUserStatusData.activationStatus !==
                      InternalUserActivationStatus.ActiveInviteAccepted
            }
        />
    );
};
